module.exports = __webpack_public_path__ + "static/media/img-4.a724eb95.jpg";